const messages = {
  name: 'Cuenta |||| Cuentas',

  fields: {
    accountName: 'Nombre de Cuenta',
    accountStatus: 'Estado de Cuenta',
    application: 'Aplicacion',
    contactCenterReplyToEmail: 'Correo de respuesta del hotel',
    maxUsers: 'Maximo de usuarios',
    userScopes: 'Permisos en esta cuenta',
    license: 'Licencia',
    licenseValidity: 'Validez de Licencia',
    licenseBlocked: 'LicenciaBloqueada',
    rateLimitApplies: 'Limite de Tasa Aplica',
    log: 'Registro',
    rateLimitPerMin: 'Limite de Tasa/Min',
    rateLimitPerDay: 'Limite de Tasa/Dia',
    whitelistApplies: 'Lista Blanca Aplica',
    provider: 'Proveedor',
    providers: 'Proveedor(es)',
    applications: 'Aplicación(es)',
    credits: 'Créditos',
    templatifyAccount: 'Cuenta Templatify',
    groups: 'Grupos',
    users: 'Usuarios',
    costCenter: 'Centro de Coste',
    apiKey: 'Clave API',
    aiAvailable: 'La cuenta puede usar IA',
    aiProvider: 'Proveedor de IA',
    aiApiKey: 'Clave API del LLM',
    aiTranscriptionApiKey: 'Clave API de transcripcion (Groq Whisper)',
    validityTimeFrame: 'Periodo de Validez de Licencia',
    loggingStrategy: 'Estrategia de Registro',
    logRetentionDays: 'Retencion de Logs (dias)',
    logRetentionDaysPlaceholder: 'Por defecto de la plataforma',
    logRetentionDaysHelp: 'Vacio = valor global de la plataforma',
    communicationTypes: 'Tipos de Comunicacion',
    communicationType: 'Tipo de Comunicacion',
    name: 'Nombre',
    surname: 'Apellidos',
    email: 'Email',
    password: 'Contrasena',
    confirmPassword: 'Confirmar Contrasena',
    userId: 'Id de Usuario',
    deviceType: 'Tipo de Dispositivo',
    token: 'Token',
    platform: 'Plataforma',
    emailAddress: 'Direccion Email',
    number: 'Numero',
    chatId: 'ID de Chat',
    rmkTemplateAccountName: 'Nombre de Cuenta Plantilla RMK',
    rmkTemplateApiKey: 'Clave API de Plantilla RMK',
    templatifyAccountName: 'Nombre de cuenta Templatify',
    templatifyGroup: 'Grupo de Templatify',
    templatifyApiKey: 'Api-key de Templatify',
    templatifyApplications: 'Aplicación de Templatify',
    ipAddress: 'Direccion IP',
  },

  filters: {
    accountName: 'Nombre de Cuenta',
    application: 'Aplicacion',
    provider: 'Proveedor',
    costCenter: 'Centro de Coste',
  },

  registry: {
    label: 'Registro de organizaciones',
    kindProperty: 'Establecimiento',
    kindOrganization: 'Organización',
    chip: 'Vinculada',
    optional: 'Elija el establecimiento u organización al que pertenece la cuenta.',
    optionalNow: 'Vincule la cuenta con su registro. No podrá cambiarse después.',
    locked: 'La cuenta ya está vinculada con su registro.',
    linked: 'Cuenta vinculada correctamente',
    conflict: 'La cuenta ya está vinculada con otro registro.',
    failed: 'No se ha podido vincular la cuenta. Inténtelo de nuevo.',
  },

  sections: {
    general: 'GENERAL',
    configuration: 'CONFIGURACION',
    ai: 'INTELIGENCIA ARTIFICIAL',
    templatify: 'TEMPLATIFY',
    options: 'OPCIONES',
  },

  options: {
    useTemplatify: 'Usar Templatify',
    contactCenterEnabled: 'Connect contratado',
    portalEnabled: 'Portal contratado',
    automationsEnabled: 'Flow contratado',
    blockedLicense: 'Licencia Bloqueada',
    rateLimitApplies: 'Aplicar Limite de Tasa',
    whitelistApplies: 'Aplicar Lista Blanca',
    addUsers: 'Anadir Usuarios',
    useTemplates: 'Usar Plantillas',
    useCostCenter: 'Usar Centro de Coste',
  },

  status: {
    active: 'Activo',
    limited: 'Limitado',
    blocked: 'Bloqueado',
  },

  logging: {
    none: 'Ninguno',
    wrong: 'Errores',
    all: 'Todo',
  },

  channels: {
    email: 'Email',
    sms: 'SMS',
    whatsapp: 'WhatsApp',
    telegram: 'Telegram',
    push: 'Push',
  },

  tabs: {
    accountInfo: 'Informacion de Cuenta',
    templatifyIntegration: 'Integracion de Templatify',
    applications: 'Aplicaciones',
  },

  templatify: {
    autoCreate: {
      title: 'Crear automaticamente cuenta Templatify',
      description: 'Una cuenta coincidente en Templatify se creara via API al guardar',
    },
    createNew: {
      title: 'Crear cuenta nueva',
      description: 'Crea una cuenta nueva en Templatify con el mismo nombre',
    },
    linkExisting: {
      title: 'Vincular a cuenta existente',
      description: 'Conectar a una cuenta que ya existe en Templatify',
    },
    validate: {
      credentialsOk: 'Conexion verificada',
      templates: 'Templates',
      action: 'Validar',
      success: 'Cuenta de Templatify verificada',
      failed: 'No se pudo validar la cuenta en Templatify',
      verified: 'Cuenta verificada en Templatify',
    },
    updateApiKey: {
      title: 'Actualizar la clave API en Templatify',
      description:
        'Introduce una clave API nueva para actualizar la integracion con Templatify. Esto reemplazara la clave existente usada para autenticacion y sincronizacion.',
      confirmTitle: 'Estas seguro de que quieres actualizar la clave API de Templatify?',
      confirmMessage:
        'Esta accion reemplazara la clave existente usada para autenticacion y sincronizacion de aplicaciones.',
      confirmYes: 'Si, actualizarla',
      confirmNo: 'No, conservar la clave existente',
    },
    accessGlobal: {
      title: 'Acceso a plantillas globales',
      description:
        'Esta cuenta podra usar plantillas marcadas como globales en Templatify',
          readonly: 'Configuracion actual de la cuenta de Templatify',
    },
    syncNote:
      'Los datos de cuenta se sincronizan entre Notify y Templatify. Las plantillas existentes en Templatify se conservan.',
  },

  applications: {
    assignedTitle: 'Aplicaciones Asignadas',
    addApplication: 'Anadir Aplicacion',
    notify: 'Notify',
    templatify: 'Templatify',
    tagNotify: 'NOTIFY',
    tagViaApi: 'VIA API',
    selectPlaceholder: 'Selecciona aplicacion',
    syncStatus: {
      existsInBoth: 'Existe en ambos',
      notifyOnly: 'Solo en Notify',
      willCreateInNotify: 'Se creara en Notify',
      willCreateInTemplatify: 'Se creara en Templatify',
    },
  },

  groups: {
    manageTitle: 'Gestionar Grupos',
    noticeTitle: 'Aviso',
    noticeBody:
      'Los grupos y miembros se asignan a las aplicaciones solo en Notify, no en Templatify.',
    addGroup: 'Anadir Grupo',
    paste: 'Pegar',
    copySuccess: 'Grupo copiado al portapapeles',
    pasteSuccess: 'Grupo pegado correctamente',
    groupName: 'Nombre del Grupo',
    addMember: 'Anadir Miembro',
    memberTitle: 'Detalles del Miembro',
    channelsHeading: 'Canales de Notificacion',
    noGroups: 'Sin Grupos',
    pickApplicationsFirst: 'Vincula al menos una aplicacion (Informacion de Cuenta o Integracion de Templatify) para gestionar sus grupos.',
  },

  actions: {
    addAccount: 'Anadir Cuenta',
    exportCsv: 'Exportar CSV',
    addToken: 'Anadir Token',
    addEmail: 'Anadir Email',
    addNumber: 'Anadir Numero',
    addChatId: 'Anadir Chat ID',
    addIpField: 'Anadir IP',
    addUser: 'Anadir Usuario',
    copyApiKey: 'Copiar Clave API',
    regenerateApiKey: 'Regenerar Clave API',
    close: 'Cerrar',
    back: 'Atras',
    next: 'Siguiente',
    submit: 'Enviar',
    discard: 'Descartar',
    remove: 'Eliminar',
  },

  placeholders: {
    expirationDateTime: 'Fecha y Hora de Expiracion',
    dateFormat: 'DD/MM/AAAA',
  },

  help: {
    contactCenterReplyToEmail:
      'Buzon real del hotel. Se pone como Reply-To en los envios para que las respuestas del huesped lleguen al hotel (que las ve siempre, aunque el contact center sea a tiempo parcial). El hotel reenvia ese buzon a {cuenta}@inbox... para que el CC tambien las ingiera.',
    sensitiveApiKeyOnEdit: 'Deja en blanco para conservar la clave existente',
    maxUsers: 'Vacio o 0 = sin tope. Al llegar al limite, la cuenta no puede crear mas usuarios.',
    noProductsContracted: 'Esta cuenta no tiene ningún producto contratado todavía: marca portal, Connect o Flow más arriba para poder dar permisos.',
    scopeCatalogUnavailable: 'No se ha podido cargar la lista de permisos. Recarga la página; si sigue igual, es que el servidor no la está sirviendo.',
    aiApiKey: 'Clave del proveedor de LLM (Gemini, Groq u OpenRouter) para las funciones de IA.',
    aiTranscriptionApiKey:
      'Opcional. Si el proveedor es Groq puede dejarse vacia y se reutiliza la key del LLM.',
    aiTranscriptionNeededForOpenRouter:
      'OpenRouter no transcribe voz. Sin una clave de Groq Whisper aqui, las notas de voz de los huespedes NO se transcribiran: el mensaje se queda con su marcador y nadie recibe un error.',
    passwordComplexity:
      'La contrasena debe tener al menos una mayuscula, una minuscula, un digito y un caracter especial.',
  },

  validation: {
    required: '%{field} es obligatorio',
    apiKeyRequired: 'La Clave API es obligatoria',
    applicationRequired: 'La aplicacion es obligatoria',
    rateLimitGtZero: '%{field} debe ser mayor que 0',
    logRetentionMin: 'La retencion de logs debe ser 0 o mas dias',
    pastDateNotAllowed:
      'El Periodo de Validez de Licencia no puede estar en el pasado',
    passwordsMismatch: 'Las contrasenas no coinciden',
    passwordMinLength: 'La contrasena debe tener al menos %{min} caracteres',
    passwordPattern:
      'La contrasena debe tener mayusculas, minusculas, un numero y un caracter especial.',
  },

  wizard: {
    stepOf: 'Paso',
    fixErrors: 'Faltan campos obligatorios — revisa el paso resaltado',
    untitled: 'Cuenta sin nombre',
    accountInfoDesc: 'Nombre, proveedores, licencia y apps',
    accountAccess: 'Acceso de la cuenta',
    accountAccessDesc: 'Límites de tasa y lista blanca de IPs',
    users: 'Usuarios',
    usersDesc: 'Usuarios opcionales de la cuenta',
    costCenter: 'Centro de coste',
    costCenterDesc: 'Asignación de facturación de créditos',
    applicationsDesc: 'Aplicaciones vinculadas',
    groups: 'Grupos',
    groupsDesc: 'Grupos de notificación por aplicación',
    templatifyDesc: 'Cuenta de renderizado de plantillas',
  },

  usersDialog: {
    editScopes: 'Permisos en esta cuenta',
    scopesSaved: 'Permisos guardados.',
    noScopes: 'Sin permisos',
    title: 'Usuarios — %{name}',
    empty: 'Esta cuenta no tiene usuarios.',
    hint: 'Estos usuarios entran con SSO al portal de clientes y al contact center de esta cuenta.',
    add: 'Añadir usuario',
    email: 'Email',
    name: 'Nombre',
    surname: 'Apellidos',
    password: 'Contraseña temporal (vacío = email de restablecimiento; mín. 12 car., mayúscula, número y símbolo)',
    phone: 'Teléfono',
    telegramChatId: 'Chat ID de Telegram',
    removeFromAccount: 'Quitar de esta cuenta',
    create: 'Crear',
    created: 'Usuario creado y añadido a la cuenta.',
    deleteTitle: '¿Eliminar a %{email} de la cuenta?',
    deleteContent: 'Se le quita el acceso a esta cuenta. Si no pertenece a ninguna otra, su usuario SSO se elimina del todo.',
    deleted: 'Usuario eliminado.',
    disabled: 'Deshabilitado',
    impersonate: 'Impersonar',
    impersonateTitle: 'Abrir como %{name}',
    impersonateHint: 'Abre el portal o el contact center haciéndote pasar por este usuario, usando tu sesión de SuperUser. Solo para soporte.',
    portal: 'Portal',
    contactCenter: 'Connect',
  },

  apiKeysDialog: {
    title: 'API keys — %{name}',
    hint: 'Cada key puede ligarse a una aplicación (fija la app del envío) o valer para toda la cuenta. El ámbito decide a qué parte del API llega.',
    empty: 'Esta cuenta no tiene API keys.',
    new: 'Nueva API key',
    colLabel: 'Etiqueta',
    colApplication: 'Aplicación',
    colScope: 'Ámbito',
    colTest: 'Test',
    colStatus: 'Estado',
    colActions: 'Acciones',
    wholeAccount: 'Toda la cuenta',
    wholeAccountOption: 'Toda la cuenta (todas las apps)',
    testBadge: 'Test',
    active: 'Activa',
    revoked: 'Revocada',
    scope: {
      manage: 'Gestión',
      send: 'Envío',
      automations: 'Flow',
    },
    scopeHint: {
      manage: 'Todo el API. Incluye registros de entrega, créditos, datos de la cuenta y contact center.',
      send: 'Solo enviar notificaciones.',
      automations: 'Solo dar de alta y actualizar reservas. Es lo que necesita un PMS.',
    },
    rotate: 'Rotar',
    revoke: 'Revocar',
    reactivate: 'Reactivar',
    createTitle: 'Nueva API key',
    editTitle: 'Editar API key',
    labelField: 'Etiqueta',
    applicationField: 'Aplicación',
    scopeField: 'Ámbito',
    testField: 'Key de test',
    created: 'API key creada.',
    updated: 'API key actualizada.',
    rotated: 'API key rotada — se ha generado un secreto nuevo.',
    reactivated: 'API key reactivada.',
    deleted: 'API key eliminada.',
    revokedMsg: 'API key revocada.',
    revealTitle: 'API key «%{label}»',
    revealWarning: 'Guárdala ahora — no se volverá a mostrar.',
    copy: 'Copiar',
    copied: 'API key copiada al portapapeles.',
    revealDone: 'Ya la he guardado',
    deleteTitle: '¿Eliminar la API key «%{label}»?',
    deleteContent: 'Deja de funcionar de inmediato. Esta acción no se puede deshacer.',
  },

  rowMenu: {
    accountInfo: 'Información de la cuenta',
    viewUsers: 'Ver usuarios',
    apiKeys: 'API keys',
    block: 'Bloquear',
    unblock: 'Desbloquear',
    costCenter: 'Centro de coste',
    creditTransactions: 'Transacciones de crédito',
  },

  info: {
    title: 'Información de la cuenta',
    general: 'General',
    license: 'Licencia',
    limits: 'Límites de tasa',
    whitelist: 'IPs en lista blanca',
    applications: 'Aplicaciones',
    providers: 'Proveedores',
    groups: 'Grupos',
    users: 'Usuarios',
    channels: 'Canales',
    none: '—',
    yes: 'Sí',
    no: 'No',
  },

  notifications: {
    created: 'Cuenta creada correctamente',
    updated: 'Cuenta actualizada correctamente',
    blocked: 'Cuenta bloqueada',
    unblocked: 'Cuenta desbloqueada',
    statusUpdateFailed: 'No se pudo actualizar el estado de la cuenta',
    deleted: '%{name} eliminado correctamente',
    loadFailed: 'Error al cargar la cuenta',
    saveFailed: 'Error al guardar la cuenta',
    apiKeyCopied: 'Clave API copiada al portapapeles',
    rmkApiKeyCopied: 'Clave API RMK copiada al portapapeles',
  },

  delete: {
    title: 'Eliminar %{recordName}?',
    content:
      'Estas seguro de que quieres eliminar esta cuenta? Esta accion no se puede deshacer.',
  },

  account: { title: 'Detalles de la cuenta' },
};

export default messages;
